import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { warningIcon } from 'assets/images';

import styles from './intro.module.scss';

const Intro = () => {
  const { t } = useTranslation('intro');

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>{t('header')}</h1>
      <div className={styles.content}>
        <div className={styles.leftContent}>
          <p style={{ textAlign: 'justify' }}>{t('welcomeP')}</p>
          <p style={{ textAlign: 'justify' }}>{t('welcomeSecondP')}</p>
          <p style={{ textAlign: 'justify' }}>{t('welcomeThirdP')}</p>

          <hr />

          <div className={styles.components}>
            <p style={{ fontWeight: '700', lineHeight: '20px' }}>
              {t('hints')}
            </p>
            <div className={styles.components}>
              <p>
                <Trans
                  i18nKey={t('hintsline')}
                  components={[
                    <i key="request" />,
                    <span
                      key="yellow"
                      style={{
                        borderRadius: '100px',
                        background: '#FFECB2',
                        padding: '2px 8px',
                        fontWeight: '500',
                      }}
                    />,
                  ]}
                />
              </p>
            </div>
            <p>
              <Trans
                i18nKey={t('hintsline2')}
                components={[
                  <i key="request" />,
                  <span
                    key="green"
                    style={{
                      borderRadius: '100px',
                      background: '#C1FFDA',
                      padding: '2px 8px',
                      fontWeight: '500',
                    }}
                  />,
                ]}
              />
            </p>
          </div>
        </div>
        <div className={styles.rightContent}>
          <img src={warningIcon} alt="Warning sign" loading="lazy" />
          <div>
            <p>
              <Trans
                i18nKey={t('access')}
                components={[
                  <b key="accesses" />,
                  <span key="token" style={{ fontFamily: 'Fira Code' }} />,
                ]}
              />
            </p>
            <p>{t('reachManager')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
